import { generateDeferredPromise } from '@utils/DeferredPomiseUtil'

declare let cordova: any

export function startBarcodeScannerHexProfile () {
    const deferred = generateDeferredPromise<any>()
    cordova.exec(
        deferred.resolve,
        deferred.reject,
        'BarcodeScanner',
        'startHexProfile',
        [],
    )
    return deferred.promise
}

export function resetBarcodeScannerProfile () {
    const deferred = generateDeferredPromise<any>()
    cordova.exec(
        deferred.resolve,
        deferred.reject,
        'BarcodeScanner',
        'resetScannerProfile',
        [],
    )
    return deferred.promise
}

export function captureBarcodeScan () {
    const deferred = generateDeferredPromise<any>()
    cordova.exec(
        deferred.resolve,
        deferred.reject,
        'BarcodeScanner',
        'captureScan',
        [],
    )
    return deferred.promise
}
